module.exports = __webpack_public_path__ + "static/media/TEST_IMAGE_HORIZONTAL.207fbaf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TEST_IMAGE_HORIZONTAL.png
// module id = 325
// module chunks = 0